<!--Only for JPPC user-->
<template>
  <div class="register_page_wrap">
    <p class="desc">お客様情報は正確に入力してください。</p>
    <ValidationObserver v-slot="{ invalid }">
      <div class="content_wrap">
        <div class="table_row name">
          <div class="table_name">名前 (漢字)</div>
          <div class="name_input_wrap">
            <div class="name_input">
              <label>姓</label>
              <ValidationProvider
                name="zenkakuChrIncludingEng"
                rules="zenkakuChrIncludingEng|required"
                v-slot="{ classes, errors }"
              >
                <v-input v-model="authData.familyName" :class="classes" />
                <div class="invalid-message">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="name_input">
              <label>名</label>
              <ValidationProvider
                name="zenkakuChrIncludingEng"
                rules="zenkakuChrIncludingEng|required"
                v-slot="{ classes, errors }"
              >
                <v-input v-model="authData.firstName" :class="classes" />
                <div class="invalid-message">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="table_row name">
          <div class="table_name">名前 (カタカナ)</div>
          <div class="name_input_wrap">
            <div class="name_input">
              <label>セイ</label>
              <ValidationProvider name="zenkakuKata" rules="zenkakuKata|required" v-slot="{ classes, errors }">
                <v-input v-model="authData.familyNameKana" :class="classes" />
                <div class="invalid-message">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="name_input">
              <label>メイ</label>
              <ValidationProvider name="zenkakuKata" rules="zenkakuKata|required" v-slot="{ classes, errors }">
                <v-input v-model="authData.firstNameKana" :class="classes" />
                <div class="invalid-message">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="table_row">
          <div class="table_name">メールアドレス</div>
          <ValidationProvider name="bankakuChr" rules="bankakuChr|email|required" v-slot="{ classes, errors }">
            <v-input class="wide_input" :class="classes" v-model="authData.email" target="email" />
            <div class="invalid-message">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="table_row">
          <div class="table_name">電話番号</div>
          <div class="tell_input_wrap">
            <v-input-number class="small_input" v-model="authData.tellNumber[0]" :max-length="5" />
            <div class="dash" />
            <v-input-number class="small_input" v-model="authData.tellNumber[1]" :max-length="4" />
            <div class="dash" />
            <v-input-number class="small_input" v-model="authData.tellNumber[2]" :max-length="4" />
          </div>
        </div>
        <div class="table_row birthday_row">
          <div class="table_name">生年月日</div>
          <div class="birthday_input_wrap">
            <ValidationProvider name="birthday" rules="birthday|required" v-slot="{ classes, errors }">
              <v-input
                v-model="authData.birthday"
                class="wide_input"
                :class="classes"
                placeholder="※ YYYYMMDD 形式で入力してください"
                target="birthday"
              />
              <div class="invalid-message">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </div>
        <div class="table_row">
          <div class="table_name">郵便番号</div>
          <div class="code_input_wrap">
            <label class="code_text">〒</label>
            <v-input-number class="small_input" v-model="authData.postCode[0]" :max-length="3" />
            <div class="dash" />
            <v-input-number class="small_input" v-model="authData.postCode[1]" :max-length="4" />
          </div>
        </div>
        <div class="table_row">
          <div class="table_name">都道府県</div>
          <custom-selectbox
            class="selectbox"
            :items="defaultFormData.PREFECTURE"
            :value="authData.prefecture"
            @custom-select="(val) => updateSelectBox(val, 'prefecture')"
          />
        </div>
        <div class="table_row">
          <div class="table_name">住所</div>
          <ValidationProvider rules="required" v-slot="{ classes, errors }">
            <v-input class="wide_input" v-model="authData.address" target="hypen" :class="classes" />
            <div class="invalid-message">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="table_row">
          <div class="table_name">建物名</div>
          <v-input class="wide_input" v-model="authData.buildingName" />
        </div>
        <div class="table_row">
          <div class="table_name">振込先</div>
          <custom-selectbox
            class="selectbox_type"
            :items="defaultFormData.APPLY_TYPE"
            :value="authData.creatorType"
            @custom-select="(val) => updateSelectBox(val, 'creatorType')"
          />
        </div>
        <div v-if="authData.creatorType === 2">
          <div class="table_row">
            <div class="table_name">法人名</div>
            <ValidationProvider
              name="zenkakuChr"
              rules="required_if:authData.creatorType,2|zenkakuChr"
              v-slot="{ errors }"
            >
              <v-input class="wide_input" v-model="authData.companyName" />
              <div class="invalid-message">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <div class="table_row">
            <div class="table_name">適格請求書発行事業者登録番号</div>
            <ValidationProvider name="alpha_num" rules="alpha_num" v-slot="{ errors }">
              <v-input class="wide_input" v-model="authData.invoiceRegistNumber" :max-length="14" />
              <div class="invalid-message">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </div>
        <!--file upload-->
        <div class="table_row file_row">
          <div class="table_name">本人確認書類及び同意書類</div>
          <div class="file_info_wrap">
            <label for="file_input" class="file_upload_btn">ドロップ ファイルを選択</label>
            <input
              class="file_input"
              type="file"
              id="file_input"
              ref="file_input"
              @change="(event) => addFiles(event.target.files, event)"
              multiple
            />
            <div class="file_list_wrap" @dragover="onDragOver" @drop="onDropFile" @click="onClickDragArea">
              <p v-if="fileList.length === 0" class="default_text">ファイルをここにドラッグ</p>
              <div v-for="(file, index) in fileList" :key="index" class="file_item">
                <div class="file_delete_btn" @click.stop="deleteFile(index)" />
                <p>{{ file.name || file.fileName }}</p>
              </div>
            </div>
            <p class="file_caution">
              ※ ファイルは最大5個まで選択可能です。<br />
              ※ 拡張子は「PDF」 「JPEG」 「JPG」 「PNG」のファイルのみアップロード可能です。<br />
              ※ 1ファイルは最大5MBまでアップロード可能です。<br />
              ※ 640×480ピクセル以下のファイルはアップロードできません。
            </p>
          </div>
        </div>
        <div class="caution_wrap">
          <ul>
            <li>
              1. 個人情報の取扱について<br />
              リワードポイントの収益化に関する手続き（以下「本手続き」といいます）にあたり、お客様からご提供いただく情報（個人情報を含む）及びアップロードいただいた書類は、ご本人確認、本手続き、NEXON会員アカウント登録情報変更に関する変更手続き及びお客様に対するサポート手続きにのみ利用し、当社の
              <a
                href="https://company.nexon.co.jp/support/privacypolicy.html?_gl=1*1vcfzsa*_gcl_au*MTc5MzY4NDg5LjE3MDA4MDc3MzA."
                target="_blank"
              >
                プライバシーポリシー
              </a>
              に基づいて管理いたします。ご確認、ご同意いただいた上、書類のアップロードをお願いいたします。
            </li>
            <li>
              2. 本人確認について<br />
              リワードポイントの収益化をご申請されるお客様は、ご申請されるクリエイターご本人であり、振込先口座がお客様ご本人名義であることを当社に対して表明保証いたします。なお、お客様が未成年者であり保護者の口座を振込先に指定する場合又はお客様がクリエイターの活動にあたり事務所等の法人に所属又は法人を運営する場合に、法人名義の口座を振込先に指定する場合には、各同意書のアップロードが必須となります。
            </li>
            <li>
              お客様情報は正確に入力してください。記載内容の不備に起因してお客様に生じる不利益につきましては当社は一切の責任を負いませんので予めご了承ください。
            </li>
            <li>
              3. 登録情報の変更について<br />
              NEXON
              会員アカウント登録時に申請いただいたお客様の情報と、本手続きの際に申請いただいた情報に異なる内容がある場合、既にご登録いただいているNEXON
              会員アカウント登録情報を本手続きで申請いただいた情報に変更いたします。予めご了承ください。
            </li>
          </ul>
        </div>
        <footer>
          <check-box
            @custom-checked="handleAgreement"
            :checked="agreement"
            id="agree"
            text="上記の内容について、同意します。"
          />
        </footer>
        <div class="btn_wrap">
          <button class="btn01 register_btn" @click="confirmAuthData" :disabled="invalid || !isValidData">送信</button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import CustomSelectbox from '@/components/atoms/CustomSelectbox';
import VInput from '@/components/atoms/VInput';
import VInputNumber from '@/components/atoms/VInputNumber';
import CheckBox from '@/components/atoms/CheckBox';
import { NJ_FORM_DATA } from '@/utils/variables';
import { mapActions } from 'vuex';
import { authNJApi } from '@/api';
import { authNJErrorMsg } from '@/utils/errorMsg';
import { calculateImgPixel } from '@/utils';

export default {
  name: 'AuthRegisterForm',
  components: {
    CustomSelectbox,
    VInput,
    VInputNumber,
    CheckBox,
  },
  props: {
    registeredData: {
      type: Object,
      default: () => {},
    },
    registeredFileList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      authData: {
        creatorType: 0,
        companyName: '',
        invoiceRegistNumber: '',
        email: '',
        tellNumber: [],
        birthday: '',
        familyName: '',
        firstName: '',
        familyNameKana: '',
        firstNameKana: '',
        postCode: [],
        prefecture: 0,
        address: '',
        buildingName: '',
      },
      fileList: [],
      deletedFileList: [],
      agreement: false,
      isClickedEditBtn: false,
    };
  },
  computed: {
    defaultFormData() {
      return NJ_FORM_DATA;
    },
    isValidData() {
      // vee-validation으로 관리하지 않는 항목 체크
      if (!this.agreement) return false;
      if (this.fileList.length === 0) return false;
      const { tellNumber, postCode } = this.authData;
      if (tellNumber.length === 0 || postCode.length === 0) return false;
      for (const num of [...tellNumber, ...postCode]) {
        if (!num) {
          return false;
        }
      }
      return true;
    },
  },
  created() {
    const { edit, restQuery } = this.$route.query;

    // 진입체크 1) 등록된 데이터를 가지고 있으며, 수정 경로로 들어오지 않은 경우
    if (!edit && Object.keys(this.registeredData).length) {
      this.$router.push({ name: 'AuthView', query: { ...restQuery } });
    }
    if (edit) {
      // 진입체크 2) 수정이면서 등록된 데이터가 없을 경우
      if (Object.keys(this.registeredData).length === 0) {
        this.$router.push({ name: 'AuthView', query: { ...restQuery } });
      }

      // 정상 수정 경로로 진입한 경우
      const { nexonSN, creatorType, prefecture, tellNumber, birthday, postCode, ...rest } = this.registeredData;
      this.authData = {
        creatorType: this.changeItemNameToIndex(NJ_FORM_DATA, 'APPLY_TYPE', creatorType),
        prefecture: this.changeItemNameToIndex(NJ_FORM_DATA, 'PREFECTURE', prefecture),
        tellNumber: tellNumber.split('-'),
        birthday: birthday.replaceAll('/', ''),
        postCode: postCode.split('-'),
        ...rest,
      };
    }
    this.fileList = this.registeredFileList;
  },
  destroyed() {
    // avoid duplicated navigator
    if (!this.$route.query.edit || this.isClickedEditBtn) return;
    const { edit, ...restQuery } = this.$route.query;
    this.$router.replace({ query: { ...restQuery } }).catch(() => {});
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    changeItemNameToIndex(list, type, targetName) {
      return list[type].findIndex((item) => item === targetName);
    },
    updateSelectBox(val, type) {
      this.authData[type] = val;
    },
    uploadedFiles(files) {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        if (files[i].sn) {
          // 기존에 있던 파일 중 유지할 파일은 append 하지 않는다
          continue;
        }
        // 새로 추가될 파일 UploadFiles key로 append
        formData.append('UploadFiles', files[i]);
      }
      // 삭제할 파일 SnList key로 append
      this.deletedFileList.forEach((file) => {
        formData.append('snList', file);
      });
      return formData;
    },
    async isValidFiles(files, event) {
      // 파일 개수 검사
      if (this.fileList.length + files.length > 5) {
        this.openModal({
          type: 'alert',
          message: 'アップロード可能なファイル数の上限を超えています。',
        });
        event.target.value = '';
        return false;
      }

      const maxSize = 5 * 1024 * 1024;
      const availableFormatList = ['pdf', 'jpeg', 'jpg', 'png'];
      let isValid = true;
      for (let i = 0; i < files.length; i++) {
        // 파일 형식 검사
        if (!availableFormatList.includes(files[i].type.split('/')[1])) {
          this.openModal({
            type: 'alert',
            message: 'このファイル形式はアップロードできません。',
          });
          event.target.value = '';
          isValid = false;
          break;
        }
        // 파일 용량 검사
        if (files[i].size > maxSize) {
          this.openModal({
            type: 'alert',
            message: 'ファイル容量が上限を超えています。',
          });
          event.target.value = '';
          isValid = false;
          break;
        }
        // 파일 해상도 검사
        if (files[i].type.includes('pdf')) continue;
        const { width, height } = await calculateImgPixel(files[i]);
        if (width <= 640 || height <= 480) {
          this.openModal({
            type: 'alert',
            message: '640x480以下のファイルはアップロードできません。',
          });
          event.target.value = '';
          isValid = false;
          break;
        }
      }
      return isValid;
    },
    async addFiles(files, event) {
      if (!(await this.isValidFiles(files, event))) return;

      for (let i = 0; i < files.length; i++) {
        this.fileList.push(files[i]);
        if (event) {
          event.target.value = '';
        }
      }
    },
    deleteFile(selectedFileIndex) {
      if (this.fileList[selectedFileIndex].sn) {
        this.deletedFileList.push(String(this.fileList[selectedFileIndex].sn));
      }
      this.fileList = this.fileList.filter((_, idx) => idx !== selectedFileIndex);
    },
    onDragOver(event) {
      event.preventDefault();
    },
    onDropFile(event) {
      event.preventDefault();
      const files = event.dataTransfer.files;
      this.addFiles(files);
    },
    onClickDragArea() {
      this.$refs.file_input.click();
    },
    hasError(res) {
      if (res?.code === -1 || res?.code === 10000 || res?.code === 5) {
        this.openModal(authNJErrorMsg(res?.message));
        return true;
      }
      return false;
    },
    confirmAuthData() {
      this.openModal({
        type: 'confirm',
        message:
          '以下の内容で送信しますか？ <br />送信後、弊社の確認が完了するまでは<br />入力した情報を修正できません。',
        btnName: {
          confirm: '送信',
          close: '入力に戻る',
        },
        callback: () => {
          this.registerAuthData();
        },
      });
    },
    async registerAuthData() {
      const { edit, ...restQuery } = this.$route.query;
      const uploadedFiles = this.uploadedFiles(this.fileList);

      // 업로드할 파일이 있을 경우에만 upload file api 호출
      let needToPostFile = false;
      for (let key of uploadedFiles.keys()) {
        if (uploadedFiles.get(key)) {
          needToPostFile = true;
          break;
        }
      }

      let fileRes;
      if (needToPostFile) {
        const { data } = await authNJApi.uploadFiles(uploadedFiles);
        fileRes = data;
      }
      if (this.hasError(fileRes)) {
        return;
      }

      // 그 외 auth data 수정/등록
      const {
        creatorType,
        prefecture,
        tellNumber,
        postCode,
        birthday,
        companyName,
        invoiceRegistNumber,
        ...restAuthData
      } = this.authData;
      const params = {
        creatorType: NJ_FORM_DATA.APPLY_TYPE[creatorType],
        prefecture: NJ_FORM_DATA.PREFECTURE[prefecture],
        birthday: this.$moment(birthday).format('YYYY/MM/DD'),
        tellNumber: `${tellNumber[0]}-${tellNumber[1]}-${tellNumber[2]}`,
        postCode: `${postCode[0]}-${postCode[1]}`,
        companyName: creatorType === 2 ? companyName : '',
        invoiceRegistNumber: creatorType === 2 ? invoiceRegistNumber : '',
        ...restAuthData,
      };

      let res;
      if (edit) {
        const { data } = await authNJApi.editAuthData(params);
        res = data;
      } else {
        const { data } = await authNJApi.setAuthData(params);
        res = data;
      }

      if (this.hasError(res)) {
        return;
      }

      this.isClickedEditBtn = true;
      this.$emit('refetch');
      this.$router.push({ name: 'AuthView', query: { ...restQuery } }).catch(() => {});
      window.scrollTo({ top: 0 });
    },
    handleAgreement(val) {
      this.agreement = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.register_page_wrap {
  color: #666;
}
.desc {
  color: #45475a;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  margin-bottom: 40px;
}
.content_wrap {
  /*width: 960px;*/
  border: 1px solid #eee;
  background: #fff;
  padding: 30px;
}
.table_row {
  display: flex;
  align-items: center;
  margin-bottom: 13px;
  gap: 60px;
}
.file_row,
.birthday_row {
  align-items: flex-start;
}
.file_info_wrap {
  width: calc(100% - 180px);
  min-height: 268px;
}
.birthday_row {
  margin-top: 16px;
  align-items: center;
}
.table_name {
  width: 120px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
input {
  font-family: 'Noto Sans JP', 'Helvetica Neue', Arial, 'Hiragino Kaku Gothic ProN', 'Hiragino Sans', Meiryo, sans-serif;
  font-size: 14px;
}
.selectbox {
  width: 160px;
}
.selectbox_type {
  width: 210px;
}
.wide_input {
  width: 400px;
}
.small_input {
  width: 100px;
}
.tell_input_wrap,
.code_input_wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.birthday_input_wrap {
  display: flex;
  flex-direction: column;
  gap: 5px;
  > p {
    font-size: 12px;
    font-weight: 400;
  }
}
.code_text {
  width: 30px;
}
.code_text,
.dash {
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
}
.dash {
  width: 6px;
  height: 1px;
  background: #707070;
}
.name_input_wrap {
  display: flex;
  gap: 30px;
  align-items: center;
}
.name_input {
  display: flex;
  gap: 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  > label {
    width: 30px;
    margin-top: 11px;
  }
}
.is-invalid {
  border: 1px solid #d83d3f;
}
.invalid-message {
  font-family: 'Noto Sans JP', 'Helvetica Neue', Arial, 'Hiragino Kaku Gothic ProN', 'Hiragino Sans', Meiryo, sans-serif;
  color: #d83d3f;
  font-weight: 400;
  font-size: 12px;
  line-height: 15.96px;
  margin-top: 6px;
}
.file_input {
  display: none;
}
.file_upload_btn {
  display: block;
  cursor: pointer;
  width: 170px;
  height: 40px;
  padding: 13.73px 15px;
  margin-bottom: 13px;
  background: #e1e3f0;
  color: #45475a;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
}
.file_list_wrap {
  height: 120px;
  margin-bottom: 5px;
  border: 1px solid #ddd;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #eee;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
  }
}
.default_text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 13px;
}
.file_item {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 8px;
  color: #666;
  font-size: 14px;
  font-weight: 400;
  cursor: default;
  &:hover {
    background: #f8f9fa;
  }
}
.file_delete_btn {
  background: url('~@/assets/images/icon_close.svg') no-repeat 0 0;
  background-size: contain;
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.file_caution {
  font-size: 12px;
  line-height: 18px;
}
.caution_wrap {
  max-height: 150px;
  overflow-y: scroll;
  padding: 20px;
  background: #f8f9fa;
  color: #333;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #ddd;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  li {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
footer {
  margin-top: 15px;
  > p {
    margin: 10px 0;
  }
}
a {
  color: #137fe2;
  font-weight: 400;
  text-decoration-line: underline;
}
.input_check {
  text-align: center;
}
.btn_wrap {
  display: flex;
  justify-content: center;
}
.register_btn {
  width: 180px;
  height: 40px;
  padding: 11px;
  margin-top: 30px;
}

@media all and (max-width: 767px) {
  .desc {
    margin-left: 30px;
  }
  .table_row {
    gap: 40px;
  }
  .table_name {
    width: 100px;
  }
  .name_input {
    > input {
      width: 140px;
    }
  }
  //.small_input {
  //  width: 80px;
  //}
  .caution_wrap {
    min-height: 256px;
  }
}

@media all and (max-width: 720px) {
  .table_row {
    &.name {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      margin-bottom: 30px;
      > span {
        width: 100%;
      }
    }
  }
}

@media all and (max-width: 560px) {
  .desc {
    margin-left: 15px;
  }
  .content_wrap {
    padding: 30px 15px;
  }
  .table_row {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 30px;
    > span {
      width: 100%;
    }
  }
  .table_name {
    width: 100%;
  }
  .name_input_wrap {
    width: 100%;
    justify-content: space-between;
  }
  .name_input {
    width: 210px;
    > label {
      width: 36px;
    }
  }
  input,
  .wide_input,
  .small_input,
  .tell_input_wrap,
  .code_input_wrap,
  .selectbox,
  .selectbox_type {
    width: 100%;
    gap: 8px;
  }
  .birthday_input_wrap {
    width: 100%;
  }
  .file_row {
    gap: 22px;
  }
  .file_info_wrap {
    width: 100%;
    position: relative;
  }
  .file_upload_btn {
    position: absolute;
    right: 0;
    top: -52px;
  }
  .register_btn {
    width: 100%;
  }
}

@media all and (max-width: 360px) {
  .name_input {
    width: 135px;
    > label {
      width: 60px;
    }
  }
  .file_upload_btn {
    position: initial;
  }
  .file_row {
    gap: 10px;
  }
}
</style>
